import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ChatBox } from './components/chat-box';
import { Ligacao } from './components/ligacao';
import { LigacaoExpert } from './components/ligacao/expert'
import { Email } from './components/email';
import { DefaultChat } from './components/default-chat';
import { ChatNotConnect } from './components/chat-not-connect';



interface ChatProps {
  isOpen: boolean;
  closeSidebar: Dispatch<SetStateAction<boolean>>;
  operadora: string
}

export const Chat = ({ closeSidebar, operadora }: ChatProps) => {
  const [chat, setChat] = useState('');
  // const { devedorFilaSelected } = useFila()

  // ${isOpen ? 'translate-x-0 ' : 'translate-x-full'}

  function handleChoice(channel: string) {
    setChat(channel)
  }

  function renderLigacao() {
    if (operadora === '3C') return <Ligacao />
    if (operadora === 'Expert') return <LigacaoExpert />
    return <></>
  }

  return (
    <div
      className={`fixed bottom-0 right-0 z-50  h-chatBar w-[20vw] border bg-white  py-2  text-gray-800  duration-300 ease-in-out translate-x-0 `}
    >
      {
        chat !== '' && (
          <div className="mb-4 mt-8 grid w-full grid-cols-4 gap-1 px-2 text-xs">
            <button
              className={`${chat === 'WhatsApp' ? 'bg-green-600 text-white' : 'bg-white text-gray-800  '
                } my-2 flex items-center justify-evenly rounded px-2 py-2 text-center font-medium`}
              onClick={() => setChat('WhatsApp')}
            >
              WhatsApp
            </button>
            <button
              className={`${chat === 'SMS' ? 'border-2 border-red-600 bg-red-600 text-white' : 'bg-white text-gray-800  '
                } my-2 rounded px-2 py-2 text-center font-medium disabled:opacity-20 hover:disabled:opacity-20`}
              onClick={() => setChat('SMS')}
              disabled
            >
              SMS
            </button>
            <button
              className={`${chat === 'Ligação' ? 'bg-green-600 text-white ' : 'bg-white text-gray-800 '
                } my-2 rounded px-2 py-2 text-center font-medium`}
              onClick={() => setChat('Ligação')}
            >
              Ligação
            </button>
            <button
              className={`${chat === 'E-mail' ? 'bg-green-600 text-white ' : 'bg-white text-gray-800  '
                } m-2 rounded px-2 py-2 text-center font-medium disabled:opacity-20 hover:disabled:opacity-20`}
              onClick={() => setChat('E-mail')}
              disabled
            >
              E-mail
            </button>
          </div>
        )
      }


      <div className="flex h-full w-full items-center justify-center ">
        {chat === 'WhatsApp' && <ChatBox type="whatsapp" />}
        {/* {chat === "SMS" && <ChatBox type="sms" />} */}
        {chat === 'SMS' && <ChatNotConnect />}
        {chat === 'Ligação' && <>{renderLigacao()}</>}
        {chat === 'E-mail' && <Email />}
        {chat === '' && <DefaultChat handleChoice={handleChoice} />}
      </div>
    </div>
  );
};
